import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogItemInstanceDTOBase } from "./CatalogItemInstanceDTOBase";
import type { CatalogItemRef } from "./CatalogItemRef";
import type { CatalogItemStaff } from "./CatalogItemStaff";
import type { StockChangeStaff } from "./StockChangeStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class CatalogItemInstanceStaff implements CatalogItemInstanceDTOBase, TrackedModernBase {
  constructor(public readonly assignId: number, public readonly itemId: CatalogItemStaff | null, public readonly priceCents: number | null, public readonly startActive: Date | null, public readonly endActive: Date | null, public readonly minQuantity: number | null, public readonly maxQuantity: number | null, public readonly allowPriceOverride: boolean | null, public readonly priceOverrideMin: number | null, public readonly priceOverrideMax: number | null, public readonly ignoreStock: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly stockChanges: Array<StockChangeStaff> | null, public readonly itemIdTargetIds: CatalogItemRef) {
    this.cbiServiceContext = null;
    this.itemIdLoaded = this.itemId != null;
    this.itemIdCached = this.itemId;
    this.stockChangesLoaded = this.stockChanges != null;
    this.stockChangesCached = this.stockChanges;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private itemIdLoaded: boolean;
  private itemIdCached: CatalogItemStaff | null;
  private stockChangesLoaded: boolean;
  private stockChangesCached: Array<StockChangeStaff> | null;
  async itemIdLazy(): Promise<CatalogItemStaff> {
    if (!this.itemIdLoaded) {
      this.itemIdCached = await this.cbiServiceContext!.catalogService().getCatalogItemStaff(this.itemIdTargetIds.assignId);
      this.itemIdLoaded = true;
    }
    return this.itemIdCached!;
  }
  async stockChangesLazy(): Promise<Array<StockChangeStaff>> {
    if (!this.stockChangesLoaded) {
      this.stockChangesCached = await this.cbiServiceContext!.catalogService().getCatalogItemInstanceStaffStockChanges(this.assignId);
      this.stockChangesLoaded = true;
    }
    return this.stockChangesCached!;
  }
}
